export function resolveFrameTarget(scene, selectedNodePath, nodeObjectMap) {
    const selected = selectedNodePath && nodeObjectMap ? nodeObjectMap.get(selectedNodePath) : undefined;
    return selected ?? scene;
}
//# sourceMappingURL=resolveFrameTarget.js.map